jQuery(document).ready(function ($) {
    const $images = $('.hero__brand__inner .u-img-container--cover'),
        $texts = $('.hero__inner__title span strong');

    let currentIndex = 0;

    setInterval(function () {
        // Remove current
        $images.eq(currentIndex).removeClass('is-active');
        $texts.eq(currentIndex).removeClass('is-active');

        // Calculate next index
        currentIndex = (currentIndex + 1) % $images.length;

        // Add next
        $images.eq(currentIndex).addClass('is-active');
        $texts.eq(currentIndex).addClass('is-active');
    }, 3000);
});
